module.exports = __webpack_public_path__ + "static/img/zyjd.afab8109.png";